<template>
    <div id="tl-app">
        <PageLoader />
        <router-view />
        <CommonModal />
        <WidgetModalContainer />
        <Toast
            :position="isV2 ? 'top-right' : 'bottom-right'"
            group="tl"
            append-to="#app"
            :success-icon="isV2 ? TOAST_SUCCESS_ICON : undefined"
            :error-icon="isV2 ? TOAST_ERROR_ICON : undefined"
            :pt="{
                root: {
                    'data-testid': 'tl-toast',
                    style: isV2 ? { top: 'var(--tl-toast-v2-top-offset)', bottom: '' } : undefined,
                },
                messageContent: { 'data-testid': 'tl-toast-content' },
                closeButton: { 'data-testid': 'tl-toast-close-button' },
            }"
        >
            <template
                v-if="isV2"
                #messageicon="slotProps"
            >
                <i :class="slotProps.class" />
            </template>
            <template
                v-if="isV2"
                #closeicon="slotProps"
            >
                <i :class="[slotProps.class, TOAST_CLOSE_ICON]" />
            </template>
        </Toast>
        <GatewayTimeoutToast />
        <div id="widget" />
    </div>
</template>

<script setup lang="ts">
import PageLoader from '@/components/panel/PageLoader.vue'
import CommonModal from '@/components/atoms/CommonModal.vue'
import WidgetModalContainer from '@/components/molecules/WidgetModalContainer.vue'
import GatewayTimeoutToast from './modules/errors/components/GatewayTimeoutToast.vue'
import { useToast } from 'primevue/usetoast'
import { usePrimeVue } from 'primevue/config'
import { useTheme } from '@primevue/themes'
import { setToastInstance } from '@/composables/notifications/toast-instance'
import { onMounted, watch } from 'vue'
import { useDesignVersion } from '@/composables/use-design-version'
import { getThemeConfig } from '@/styles/theme/install'
import { tlPrimePresetV1 } from '@/styles/theme/primeThemeConfig.v1'
import { tlPrimePresetV2 } from '@/styles/theme/primeThemeConfig'
import v1FontsCSS from '@/styles/v1-fonts.css?raw'
import v2FontsCSS from '@/styles/v2-fonts.css?raw'

const { isV2 } = useDesignVersion()
const primevue = usePrimeVue()
const TOAST_SUCCESS_ICON = 'tli-approve-check'
const TOAST_ERROR_ICON = 'tli-close'
const TOAST_CLOSE_ICON = 'tli-close'

const fontStyleEl = document.createElement('style')
document.head.appendChild(fontStyleEl)

watch(isV2, (v2) => {
    const themeConfig = getThemeConfig(v2 ? tlPrimePresetV2 : tlPrimePresetV1)
    primevue.config.theme = themeConfig
    useTheme(themeConfig)
    document.body.classList.toggle('design-v2', v2)
    document.body.classList.toggle('design-v1', !v2)
    fontStyleEl.textContent = v2 ? v2FontsCSS : v1FontsCSS
}, { immediate: true })

onMounted(() => {
    const toast = useToast()
    setToastInstance(toast)
})
</script>

<style lang="sass" scoped>
#tl-app
    transition: all .2s
    min-height: 100vh
    display: block
    position: relative
</style>
